import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=4841d2a1&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=4841d2a1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841d2a1",
  null
  
)

export default component.exports